// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1W89w","choiceBoxes":"toolbarselects_choiceBoxes__1CkBZ","simpleField":"toolbarselects_simpleField__1OlZi"};